(() => {
  const init = (root) => {
    if (!root || root.dataset.inited) return;
    root.dataset.inited = '1';
    const layout = root.dataset.layout;

    // Slider
    if (layout === 'slider') {
      const track = root.querySelector('.in-play-list');
      const prev = root.querySelector('.in-play-prev');
      const next = root.querySelector('.in-play-next');
      if (track && prev && next) {
        const step = () => track.clientWidth * 0.9;
        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        root.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
          if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
        });
      }

      // Autoplay (opt-in)
      if (track && root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const mode = 'continuous'; // single, smooth mode by default
        const pauseOnHover = root.dataset.autoplayPauseHover === 'true';
        const loop = root.dataset.autoplayLoop !== 'false';
        const ensureReady = (fn) => {
          // Wait until we have scrollable overflow or timeout
          const startedAt = performance.now();
          const ready = () => track.scrollWidth > track.clientWidth + 8 && track.children.length > 1;
          const tick = () => {
            if (ready() || performance.now() - startedAt > 5000) fn(); else setTimeout(tick, 120);
          };
          // Also recheck when images load
          track.querySelectorAll('img').forEach(img => {
            if (!img.complete) img.addEventListener('load', () => { /* passive reflow */ }, { once: true });
          });
          setTimeout(tick, 320);
        };

        if (mode === 'step') {
          const interval = Math.max(500, parseInt(root.dataset.autoplayInterval || '4000', 10));
          const stepPx = Math.max(20, parseInt(root.dataset.autoplayStep || '160', 10));
          let timer = null; let running = false;
          const atEnd = () => track.scrollLeft + track.clientWidth + 1 >= track.scrollWidth;
          const tick = () => {
            if (!running) return;
            if (atEnd()) { if (loop) track.scrollTo({ left: 0, behavior: 'instant' }); else { stop(); return; } }
            else { track.scrollBy({ left: stepPx, behavior: 'smooth' }); }
          };
          const start = () => { if (timer) return; running = true; timer = setInterval(tick, interval); };
          const stop  = () => { running = false; if (timer) clearInterval(timer); timer = null; };
          root.__inPlayAutoplay = { start, stop };
          const io = new IntersectionObserver((e) => { const v=e[0]; if (v && v.isIntersecting) ensureReady(start); else stop(); }, { threshold: 0.2 }); io.observe(root);
          // If already visible, arm immediately after readiness
          const rect = root.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight)) {
            ensureReady(start);
          }
          if (pauseOnHover) { root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', () => { if (document.visibilityState === 'visible') start(); }); }
          document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') stop(); else start(); });
          if (prev) prev.addEventListener('click', stop); if (next) next.addEventListener('click', stop);
          track.addEventListener('pointerdown', stop, { passive: true });
          track.addEventListener('pointerup', () => { if (document.visibilityState === 'visible') start(); }, { passive: true });
        } else {
          // Continuous smooth autoplay
          // Duplicate content once for seamless looping
          const startContinuous = () => {
            if (!track.dataset.loopCloned) {
              track.dataset.loopCloned = '1';
              const html = track.innerHTML;
              track.insertAdjacentHTML('beforeend', html);
            }
            const speed = Math.max(5, parseInt(root.dataset.autoplaySpeed || '30', 10)); // px per sec
            const origWidth = () => Math.floor(track.scrollWidth / 2);
            let rafId = 0; let last = 0; let running = false;
            const stepFrame = (ts) => {
              if (!running) return;
              if (!last) last = ts; const dt = (ts - last) / 1000; last = ts;
              track.scrollLeft += speed * dt;
              const ow = origWidth();
              if (track.scrollLeft >= ow) track.scrollLeft -= ow;
              rafId = requestAnimationFrame(stepFrame);
            };
            const start = () => { if (running) return; running = true; last = 0; rafId = requestAnimationFrame(stepFrame); };
            const stop  = () => { running = false; if (rafId) cancelAnimationFrame(rafId); rafId = 0; };
            root.__inPlayAutoplay = { start, stop };

            const maybeStart = () => {
              if (document.visibilityState !== 'visible') return;
              const rect = root.getBoundingClientRect();
              if (rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight)) {
                start();
              }
            };

            const io = new IntersectionObserver((e) => { const v=e[0]; if (v && v.isIntersecting) start(); else stop(); }, { threshold: 0.2 }); io.observe(root);
            maybeStart();

            if (pauseOnHover) { root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', () => maybeStart()); }
            document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') stop(); else start(); });
            track.addEventListener('pointerdown', stop, { passive: true });
            track.addEventListener('pointerup', () => { maybeStart(); }, { passive: true });
            if (prev) prev.style.display = 'none'; if (next) next.style.display = 'none';
          };

          ensureReady(() => {
            startContinuous();
            const ctrl = root.__inPlayAutoplay;
            if (ctrl) {
              const rect = root.getBoundingClientRect();
              if (rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight)) {
                ctrl.start();
              }
            }
          });
        }
      }
    }

    // Lightbox
    const lightbox = root.querySelector('.in-play-lightbox');
    if (lightbox) {
      const img = lightbox.querySelector('.in-play-lightbox__img');
      const captionEl = lightbox.querySelector('.in-play-lightbox__caption');
      const open = (src, alt, caption) => {
        if (root.__inPlayAutoplay) root.__inPlayAutoplay.stop();
        img.src = src; img.alt = alt || '';
        if (caption) { captionEl.textContent = caption; captionEl.hidden = false; } else { captionEl.textContent = ''; captionEl.hidden = true; }
        lightbox.hidden = false;
        document.addEventListener('keydown', onKey);
      };
      const close = () => {
        lightbox.hidden = true; img.src = ''; img.alt = '';
        captionEl.textContent = ''; captionEl.hidden = true;
        document.removeEventListener('keydown', onKey);
        if (root.__inPlayAutoplay && document.visibilityState === 'visible') root.__inPlayAutoplay.start();
      };
      const onKey = (e) => { if (e.key === 'Escape') close(); };
      lightbox.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', close));
      root.querySelectorAll('[data-action="lightbox"]').forEach(btn => {
        btn.addEventListener('click', () => open(btn.dataset.src, btn.dataset.alt, btn.dataset.caption));
      });
    }
  };

  const initAll = () => document.querySelectorAll('[data-section-type="in-play-gallery"]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
